import { useId } from 'react';
import type { SVGProps } from 'react';

const SvgPromoTagIllustration = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    fill="none"
    viewBox="0 0 100 100"
    {...props}
  >
    <defs>
      <linearGradient
        id={gradientId}
        x1="50"
        y1="0"
        x2="50"
        y2="100"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7749" />
        <stop offset="1" stopColor="#5F59FF" />
      </linearGradient>
    </defs>
    {/* Gradient ring */}
    <circle cx="50" cy="50" r="48.5" stroke={`url(#${gradientId})`} strokeWidth="3" />
    {/* Tag icon, centered (scaled from 35.3252×35.3252 to ~40×40, offset to center) */}
    <g transform="translate(30 30) scale(1.1323)">
      <path
        d="M10.1667 11C10.6269 11 11 10.6269 11 10.1667C11 9.70643 10.6269 9.33333 10.1667 9.33333C9.70643 9.33333 9.33333 9.70643 9.33333 10.1667C9.33333 10.6269 9.70643 11 10.1667 11Z"
        fill="black"
      />
      <path
        d="M18.6433 1.97667C18.0184 1.3515 17.1707 1.00019 16.2867 1H4.33333C3.44928 1 2.60143 1.35119 1.97631 1.97631C1.35119 2.60143 1 3.44928 1 4.33333V16.2867C1.00019 17.1707 1.3515 18.0184 1.97667 18.6433L16.4833 33.15C17.2409 33.9027 18.2654 34.3252 19.3333 34.3252C20.4013 34.3252 21.4258 33.9027 22.1833 33.15L33.15 22.1833C33.9027 21.4258 34.3252 20.4013 34.3252 19.3333C34.3252 18.2654 33.9027 17.2409 33.15 16.4833L18.6433 1.97667Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1667 11C10.6269 11 11 10.6269 11 10.1667C11 9.70643 10.6269 9.33333 10.1667 9.33333C9.70643 9.33333 9.33333 9.70643 9.33333 10.1667C9.33333 10.6269 9.70643 11 10.1667 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
  );
};

export default SvgPromoTagIllustration;
